<div class="row h650">

  <div class="col-md-6 h600">
    <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">

      <div class="box-header text-center">
        <h3 class="box-title ">
          <i *ngIf="this.isLoadingCadastrados" class="fa fa-spinner fa-spin fa-fw pull-left"></i>
          Grupos Local Nível Cadastrados
        </h3><br />
        <span class="text-muted">Selecione para editar</span>
      </div>

      <div class="box-body">

        <div class="box-table h500">

          <table>
            <thead>
              <tr>
                <th class="text-center wf120">
                  <i *ngIf="this.isLoadingCadastrados" class="fa fa-spinner fa-spin fa-fw pull-left"></i>Descrição
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of this.cadastrados" class="cp" (click)="getById(c.id)"
                [ngClass]="{'tr-info': c.id == this.form.get('id').value}">
                <td class="text-center">{{ c.nome }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="box-footer">
        <section *ngIf="this.cadastrados?.length > 0">
          <span class="pl-1">Total: <b>{{ this.cadastrados?.length }}</b> </span>
        </section>
        <section *ngIf="this.cadastrados?.length == 0">
          <span class="pl-1"><b>Nenhum resultado</b> </span>
        </section>
      </div>
    </div>
  </div>



  <div class="col-md-6">
    <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">

      <div class="box-body" style="height: 605px;">


        <form novalidate class="pt-30" [formGroup]="form" id="form" (validSubmit)="submit()">

          <div class="form-row">
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <div class="position-relative form-group">
                <label for="nome">Descricao</label>
                <input class="form-control" formControlName="nome" type="text" maxlength="90" required />
              </div>
            </div>
          </div>




        </form>


      </div>
      
      <div class="text-center h30" >
        <app-ball-pulse *ngIf="isProcessing"></app-ball-pulse>
      </div>
    </div>
   

  </div>
</div>

<div class="row mt-3">
  <div class="col-md-12">
    <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">
      <div class="box-body">
        <div class="row">
          <div class="col-md-3">
            <div class="d-flex justify-content-start">
              <button type="button" class="btn btn-light pl-3 pr-3 mr-3"
                [disabled]="!(this.isEditing && this.autorizacoes?.podeExcluir)"
                title="Exluir Grupo local selecionado"
                (click)="questionDelete(this.form.get('id').value)">
                <span class="text-danger"><i class="fa fa-trash"></i></span><span class="pl-3">Excluir</span>
              </button>
            </div>
          </div>
          <div class="col-md-3">
            <div class="d-flex justify-content-center">
              <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/homePeq.png" /></a>
            </div>
          </div>
          <div class="col-md-6">

            <div class="d-flex justify-content-end">

              <button type="button" class="btn btn-light pl-5 pr-5 mr-3" (click)="reset()">Limpar</button>


              <button type="submit" class="btn pr-3 pr-3 mr-3 btn-shadow" form="form"
                [ngClass]="{'btn-primary' : !this.isEditing, 'btn-warning': this.isEditing}"
                [disabled]="form.invalid || !(this.autorizacoes?.podeIncluir && autorizacoes?.podeAlterar)"
                >
                <i class="fa fa-floppy-o pr-2"></i>
                <span *ngIf="!this.isEditing" class="pl-5 pr-5">Inserir</span>
                <span *ngIf="this.isEditing" class="pl-5 pr-5">Editar</span>
              </button>

            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</div>